import { notices } from "../utils/domain/model.js";
import { state } from "../state/workspaceStore.js";
import { head } from "../components/common/PageHeader.jsx";
import { btn } from "../components/forms/FormControls.jsx";
import { nodes, attributes } from "../components/common/reactHelpers.jsx";
import { esc } from "../utils/format.js";
import { tableViews } from "../components/tables/RecordTable.jsx";
export function notifications() {
  let ns = notices(state.db);
  return (
    <>
      {head(
        "INBOX",
        "Notifications",
        "Actionable updates generated from current records.",
        btn("Mark all read", 'data-action="read-all"', true),
      )}
      {
        <div className={"card"}>
          {nodes(
            ns.map((n) => (
              <div
                className={
                  "notification " +
                  (state.db.notificationsRead.includes(n.signature)
                    ? "read"
                    : "")
                }
              >
                <span className={"note-icon"}>{"\u2726"}</span>
                <div>
                  <button className={"text-btn"} data-nav={n.route}>
                    {esc(n.title)}
                    {" \u2192"}
                  </button>
                  <p>{esc(n.body)}</p>
                </div>
                <button
                  className={"text-btn"}
                  data-read={n.signature}
                  {...attributes(
                    state.db.notificationsRead.includes(n.signature)
                      ? "disabled"
                      : "",
                  )}
                >
                  {state.db.notificationsRead.includes(n.signature)
                    ? "Read"
                    : "Mark read"}
                </button>
              </div>
            )),
          ) || <p className={"empty"}>{"No actions need your attention."}</p>}
        </div>
      }
    </>
  );
}
export default function NotificationsPage({ recordId } = {}) {
  return tableViews(notifications());
}
